import { genThumbMediaURI, MediaUrlOptions } from '@miq/utils';
import { MediaInfo } from './stacking-plan-container/stacking-plan.model';

export function genThumbnailUrl(
  url: string,
  mediaOptions: MediaInfo,
  options: MediaUrlOptions & { provideDefault?: boolean } = {}
): string {
  const { edpMultimediaKey, thumbLocationURI } = mediaOptions;
  url = url.includes(edpMultimediaKey) ? url : `${edpMultimediaKey}${'/'}${url}`;
  return genThumbMediaURI(edpMultimediaKey, thumbLocationURI, url, options);
}
